import React, { useState } from "react";
import Popover from "@mui/material/Popover";
import { MoreVert } from "@mui/icons-material";
import { display } from "@mui/system";
import {
  getKanbanCheck,
  getKanbanInbox,
  updateBucketPosition,
  updateBucketStatus,
} from "../../dispatchers/clinicalChecksDispatchers";
import useTitanApp from "../../hooks/useTitanApp";
import {
  setKanbanChecks,
  setKanbanInbox,
} from "../../features/clinicalChecksSlice/clinicalChecksSlice";

export default function SortingMenu({
  prescriptionIncomingId,
  movePrescriptionInList,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const { appState, clincicalChecksState } = useTitanApp();
  const { currentPharmacyId } = appState || {};
  const { kanbanInbox, KanbanChecks } = clincicalChecksState || {};
  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (bucketStatus) => {
    try {
      let positionNumber = null;

      if (bucketStatus === 3) {
        positionNumber = 0;
      } else if (bucketStatus === 1 || bucketStatus === 2) {
        positionNumber = -0.5;
      } else if (bucketStatus === "bottom") {
        positionNumber = 0.5;
      }

      if (bucketStatus === 1 || bucketStatus === 2 || bucketStatus === 3) {
        updateBucketStatus({
          pharmacyID: currentPharmacyId,
          batchId: "00000000-0000-0000-0000-000000000000",
          prescriptionIncomingId: prescriptionIncomingId,
          bucketStatus: bucketStatus,
        }).then(() => {
          if (positionNumber !== null) {
            updateBucketPosition({
              pharmacyID: currentPharmacyId,
              bucketStatusBody: {
                prescriptionIncomingId: prescriptionIncomingId,
                positionNumber: positionNumber,
              },
            });
          }
          getKanbanInbox(currentPharmacyId);
          getKanbanCheck(currentPharmacyId);
        });
      } else if (bucketStatus === "top" || bucketStatus === "bottom") {
        movePrescriptionInList(bucketStatus, prescriptionIncomingId);
      }
    } catch (error) {
      console.log(error);
    }

    handleClose();
  };

  const options = [
    { label: "Send to Waiting", value: 1 },
    { label: "Send to Today", value: 2 },
    { label: "Send to Unallocated", value: 3 },
    { label: "Send to Top", value: "top" },
    { label: "Send to Bottom", value: "bottom" },
  ];

  return (
    <div>
      <button onClick={handleClick}>
        <p>...</p>
      </button>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        className="sorting-popover"
      >
        <div className="inner-popover">
          {options.map((option, index) => (
            <button
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                handleSelect(option.value);
              }}
              className=""
            >
              {option.label}
            </button>
          ))}
        </div>
      </Popover>
    </div>
  );
}
